import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTime = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m45 54 4 4 9-9m1.97-7.9q.03-.546.03-1.1c0-11.046-8.954-20-20-20s-20 8.954-20 20c0 10.87 8.673 19.716 19.477 19.993M40 28v12l7.477 3.738"
    />
  </svg>
);
export default SvgTime;
